"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from "react";
function getViewportBottom(): number {
  const vv = window.visualViewport;
  if (vv) {
    return vv.offsetTop + vv.height;
  }
  return window.innerHeight;
}
export function useFillViewportHeight(t0) {
  const $ = _c(8);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    enabled: t2,
    minHeight: t3
  } = t1;
  const enabled = t2 === undefined ? true : t2;
  const minHeight = t3 === undefined ? 0 : t3;
  const ref = useRef(null);
  const [style, setStyle] = useState();
  let t4;
  let t5;
  if ($[2] !== enabled || $[3] !== minHeight) {
    t4 = () => {
      const element = ref.current;
      if (!element || !enabled) {
        return;
      }
      const measure = () => {
        const {
          top
        } = element.getBoundingClientRect();
        const viewportBottom = getViewportBottom();
        const parent = element.parentElement;
        const bottom = parent ? Math.min(viewportBottom, parent.getBoundingClientRect().bottom - (Number.parseFloat(getComputedStyle(parent).paddingBottom) || 0)) : viewportBottom;
        setStyle({
          height: `${Math.max(minHeight, Math.floor(bottom - top))}px`
        });
      };
      measure();
      const observer = new ResizeObserver(measure);
      observer.observe(element);
      if (element.parentElement) {
        observer.observe(element.parentElement);
      }
      const viewport = window.visualViewport;
      window.addEventListener("resize", measure);
      viewport?.addEventListener("resize", measure);
      viewport?.addEventListener("scroll", measure);
      return () => {
        observer.disconnect();
        window.removeEventListener("resize", measure);
        viewport?.removeEventListener("resize", measure);
        viewport?.removeEventListener("scroll", measure);
      };
    };
    t5 = [enabled, minHeight];
    $[2] = enabled;
    $[3] = minHeight;
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  useEffect(t4, t5);
  let t6;
  if ($[6] !== style) {
    t6 = {
      ref,
      style
    };
    $[6] = style;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  return t6;
}